<template>
  <b-modal
    id="modal-role"
    title="Thêm mới vai trò"
    size="md"
    centered
    hide-footer
    @hide="reset"
  >
    <b-overlay :show="loading">
      <form @submit.prevent="handleValidate">
        <!-- 1. Chọn phòng ban trước -->
        <b-row>
          <b-col>
            <label class="required">Phòng ban <span class="text-danger">*</span></label>
            <div class="department-combobox">
              <b-input-group>
                <b-form-input
                  v-model="deptSearch"
                  placeholder="Tìm hoặc nhập tên phòng ban"
                  autocomplete="off"
                  @input="onDeptInput"
                  @focus="openDropdown"
                  @blur="closeDropdown"
                />
                <b-input-group-append v-if="showAddBtn">
                  <b-button variant="success" @click.prevent="addPendingDepartment" title="Thêm phòng ban này">
                    +
                  </b-button>
                </b-input-group-append>
              </b-input-group>

              <div v-if="deptError" class="text-danger" style="font-size:12px;margin-top:4px">Phòng ban là bắt buộc</div>

              <div v-if="dropdownOpen && filteredDepts.length" class="dept-dropdown">
                <div
                  v-for="dept in filteredDepts"
                  :key="dept.id"
                  class="dept-dropdown-item"
                  @mousedown.prevent="selectDept(dept)"
                >
                  {{ dept.name }}
                </div>
              </div>

              <div v-if="selectedDept" class="mt-2">
                <b-badge variant="primary" class="p-2" style="font-size:13px">
                  {{ selectedDept.name }}
                  <span class="ml-1" style="cursor:pointer" @click="clearDept">&times;</span>
                </b-badge>
                <span v-if="selectedDept._isNew" class="text-muted ml-2" style="font-size:12px">(sẽ tạo mới khi lưu)</span>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- 2. Nhập tên vai trò -->
        <b-row class="mt-3">
          <b-col>
            <basic-input
              :required="true"
              label="Tên vai trò"
              name="name"
              placeholder="Nhập tên vai trò"
              :value.sync="name"
              :state="validateState('name')"
              :invalidFeedback="errors.first('name')"
              v-validate="'required|max:20'"
              data-vv-as="Tên vai trò"
              maxlength="20"
            />
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-4">
          <b-button class="btn mr-4" type="button" @click="cancel">
            Hủy
          </b-button>
          <b-button class="btn btn-success" type="submit">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
            </span>
            Lưu
          </b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>
<script>
import DepartmentService from '../services/department.service';
export default {
  name: 'ModalRole',
  props: {
    departments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      name: null,
      deptSearch: '',
      selectedDept: null,
      dropdownOpen: false,
      localDepartments: [],
      deptError: false,
    };
  },
  computed: {
    allDepartments() {
      return [...this.departments, ...this.localDepartments];
    },
    filteredDepts() {
      if (!this.deptSearch) return this.allDepartments;
      const q = this.deptSearch.toLowerCase();
      return this.allDepartments.filter((d) =>
        d.name.toLowerCase().includes(q),
      );
    },
    showAddBtn() {
      if (!this.deptSearch || this.selectedDept) return false;
      const exact = this.allDepartments.find(
        (d) => d.name.toLowerCase() === this.deptSearch.toLowerCase(),
      );
      return !exact;
    },
  },
  methods: {
    onDeptInput() {
      this.selectedDept = null;
      this.dropdownOpen = true;
    },
    openDropdown() {
      this.dropdownOpen = true;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    selectDept(dept) {
      this.selectedDept = dept;
      this.deptSearch = dept.name;
      this.dropdownOpen = false;
      this.deptError = false;
    },
    addPendingDepartment() {
      const pending = { id: `__pending__${Date.now()}`, name: this.deptSearch, _isNew: true };
      this.localDepartments.push(pending);
      this.selectedDept = pending;
      this.dropdownOpen = false;
      this.deptError = false;
    },
    clearDept() {
      this.selectedDept = null;
      this.deptSearch = '';
    },
    handleValidate() {
      this.deptError = !this.selectedDept;
      this.$validator.validateAll().then((result) => {
        if (result && !this.deptError) {
          this.onClickSaveButton();
        }
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    getRoleFullName() {
      if (!this.selectedDept) return this.name;
      // Remove spaces and special chars from dept name for code
      const deptCode = this.selectedDept.name.replace(/\s+/g, '');
      return `${this.name}_${deptCode}`;
    },
    async onClickSaveButton() {
      try {
        this.loading = true;
        let departmentId = this.selectedDept && !this.selectedDept._isNew
          ? this.selectedDept.id
          : null;

        if (this.selectedDept && this.selectedDept._isNew) {
          const { meta: dm, data: deptData } = await DepartmentService.create(this.$api, {
            name: this.selectedDept.name,
          });
          if (dm.success && deptData?.id) {
            departmentId = deptData.id;
            this.$emit('department-created', deptData);
          }
        }

        // Auto append department name to role: Leader_Technology
        const roleFullName = this.getRoleFullName();
        const { meta, error, data } = await this.$api.post('/Role', {
          name: roleFullName,
          code: roleFullName,
        });
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
            preventDuplicates: true,
          });
        }
        if (departmentId && data?.id) {
          await DepartmentService.assignRole(this.$api, departmentId, data.id);
        }
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Thêm vai trò thành công',
        });
        this.$emit('add-success');
        this.cancel();
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
          preventDuplicates: true,
        });
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$bvModal.hide('modal-role');
    },
    reset() {
      this.name = null;
      this.deptSearch = '';
      this.selectedDept = null;
      this.dropdownOpen = false;
      this.localDepartments = [];
      this.deptError = false;
    },
  },
};
</script>
<style scoped>
.department-combobox {
  position: relative;
}
.dept-dropdown {
  position: absolute;
  z-index: 9999;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.dept-dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}
.dept-dropdown-item:hover {
  background: #f3f6f9;
}
</style>
